import React from 'react'

function Offer() {
  return (
    <div id='offer'>
      <div className='pr-heading'>
        <h1>A BIG <span>OFFER</span>FOR THIS SUMMER</h1>
        <p className="details">The best summer deal don't be late hurry up it will over</p>
        <div className="pr-btns">
            <a href="/" className="pr-btn">Join Now</a>
        </div>
      </div>
    </div>
  )
}

export default Offer
